import {createContext, useContext, useState, useEffect, ReactNode} from "react";
import {OrganizationFA} from "../interfaces/global-interfaces";
import {getOrganizations} from "../services/apiService";

interface OrganizationContextType {
    organizations: OrganizationFA[];
    selectedOrganizationId: string;
    setSelectedOrganizationId: React.Dispatch<React.SetStateAction<string>>;
    selectedOrganization: OrganizationFA | undefined;
    setOrganizations: React.Dispatch<React.SetStateAction<OrganizationFA[]>>;
}

const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);

export const OrganizationProvider = ({children}: { children: ReactNode }) => {
    const [organizations, setOrganizations] = useState<OrganizationFA[]>([]);
    const [selectedOrganizationId, setSelectedOrganizationId] = useState<string>("");
    const [selectedOrganization, setSelectedOrganization] = useState<OrganizationFA | undefined>(undefined);

    useEffect(() => {
        const loadOrganizations = async () => {
            try {
                const data = await getOrganizations();
                setOrganizations(data);
                if (data.length > 0 && !selectedOrganizationId) {
                    setSelectedOrganizationId(data[0]._id!);
                }
            } catch (error) {
                console.error("Errore caricamento organizzazioni:", error);
            }
        };

        void loadOrganizations();
    }, [selectedOrganizationId]);

    // Aggiorna l'organizzazione selezionata ogni volta che cambia l'ID
    useEffect(() => {
        const org = organizations.find(o => o._id === selectedOrganizationId);
        setSelectedOrganization(org);
    }, [selectedOrganizationId, organizations]);

    return (
        <OrganizationContext.Provider
            value={{organizations, selectedOrganizationId, setSelectedOrganizationId, selectedOrganization, setOrganizations}}
        >
            {children}
        </OrganizationContext.Provider>
    );
};

export const useOrganization = () => {
    const context = useContext(OrganizationContext);
    if (!context) {
        throw new Error("useOrganization must be used within an OrganizationProvider");
    }
    return context;
};

